var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import styled from 'styled-components';
export var DropdownTextInput = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  line-height: 16px;\n  height: 100%;\n  font-family: arial;\n  box-sizing: border-box;\n  padding: 0px;\n  width: 100%;\n  color: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  background: none;\n  border: none;\n  outline: none;\n  font-size: 12px;\n  line-height: 16px;\n  height: 100%;\n  font-family: arial;\n  box-sizing: border-box;\n  padding: 0px;\n  width: 100%;\n  color: ", ";\n\n  &::placeholder {\n    color: ", ";\n  }\n"])), function (_a) {
    var color = _a.color;
    return color || null;
}, function (_a) {
    var placeholderColour = _a.placeholderColour;
    return placeholderColour || null;
});
var templateObject_1;
//# sourceMappingURL=DropdownTextInput.js.map